/***
 *
 * This module allows us to read geolocation data from a window object. These values are written statically during server-side rendering,
 * written into the HTML template when the app is loaded, and then loaded into memory when the browser parses the document.
 *
 * Currently, the HTML template is generated inside TOSA's parent application (the website), so some of this code has been copied from the SSR code here:
 *
 * /domains/website/website/src/server/utils/getGeolocationDataFromHeaders.ts
 *
 * When TOSA is eventually deployed independently as a statically-generated application, this code will need to reproduced in the portion that creates an HTML template
 *
 */

import { browserOnly } from '@farmersdog/utils';
type GeolocationProperties =
  | 'dma'
  | 'city'
  | 'state'
  | 'zip'
  | 'country'
  | 'ip';

type GeolocationHeaderMap = {
  [k in GeolocationProperties]: string;
};

export const geoLocationHeaderMap: GeolocationHeaderMap = {
  dma: 'cf-metro-code',
  city: 'cf-ipcity',
  state: 'cf-region-code',
  zip: 'cf-postal-code',
  country: 'cf-ipcountry',
  ip: 'cf-connecting-ip',
};

export type GeolocationData = {
  [k in GeolocationProperties]?: string;
};

export const geolocationWindowProperty = '__geolocationData';

declare global {
  interface Window {
    [geolocationWindowProperty]?: GeolocationData;
  }
}

export function getGeolocationData() {
  return browserOnly(
    (window: Window) => {
      return window[geolocationWindowProperty] ?? {};
    },
    () => ({}) as GeolocationData
  );
}
